import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type AddTicketDTO =  {
    subject:string;
    supportMessages:SupportMessage[]
    category:string;
}
export type SupportMessage = {
    id?:string;
    ticketId?:string;
    adminId?: string | null;
    studentId?: string | null;
    createdAt?:string;
    updatedAt?:string;
    message:string;
    attachments:string[]
}
type AddTicketResponse  = AddTicketDTO & ApiError;

export const AddNewTicket = (data: AddTicketDTO): Promise<AddTicketResponse> => {
    return axios.post("/support/create-ticket", data)
        .then(response => response.data as AddTicketResponse);
};